module.exports = __webpack_public_path__ + "static/python-067050f6ecc418ea7a7d2f3557683c8c.png";